module.exports = __webpack_public_path__ + "img/loading.2056f7fe.gif";